<div class="row">
  <div class="col-12 col-md">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor"
      stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="d-block mb-2" role="img"
      viewBox="0 0 24 24">
      <title i18n>Artikel</title>
      <circle cx="12" cy="12" r="10" />
      <path d="M14.31 8l5.74 9.94M9.69 8h11.48M7.38 12l5.74-9.94M9.69 16L3.95 6.06M14.31 16H2.83m13.79-4l-5.74 9.94" />
    </svg>
    <small class="d-block mb-3 text-muted">&copy; 2023–2024</small>
  </div>
  <div class="col-6 col-md">
    <h5 i18n>Einkaufen</h5>
    <ul class="list-unstyled text-small">
      <li><a class="link-secondary" href="#" i18n>Startseite</a></li>
    </ul>
  </div>
  <div class="col-6 col-md">
    <h5 i18n>Regulatorik</h5>
    <ul class="list-unstyled text-small">
      <li><a class="link-secondary" [routerLink]='["/legalnotes"]' i18n>Impressum</a></li>
      <li><a class="link-secondary" href="#" i18n>Datenschutz</a></li>
      <li><a class="link-secondary" href="#" i18n>AGB</a></li>
    </ul>
  </div>
  <div class="col-6 col-md">
    <h5 i18n>Über uns</h5>
    <ul class="list-unstyled text-small">
      <li><a class="link-secondary" [routerLink]='["/aboutus"]' i18n>Über uns</a></li>
      <li><a class="link-secondary" [routerLink]='["/contact"]' i18n>Kontakt</a></li>
    </ul>
  </div>
</div>